import { AjaxService } from 'Angular/services/core/ajax.service';
import { UrlsService } from 'Angular/services/core/urls.service';
import * as i0 from "@angular/core";
import * as i1 from "Angular/services/core/ajax.service";
import * as i2 from "Angular/services/core/urls.service";
export class AvisoIntegrationService {
    constructor(ajaxService, urlsService) {
        this.ajaxService = ajaxService;
        this.urlsService = urlsService;
    }
    getAvisoAccountSearchResults(searchTerms, page) {
        const url = `${this.urlsService.getUrl(this.urlsService.INTEGRATIONS.AVISO_SEARCH)}?searchTerms=${searchTerms}&page=${page}`;
        return this.ajaxService.getDataObserveBody(url);
    }
    importAvisoAccountHoldings(postParams) {
        const url = this.urlsService.INTEGRATIONS.AVISO_IMPORT_ACCOUNT_HOLDINGS;
        return this.ajaxService.postJsonDataObserveBody(url, postParams);
    }
    activateAvisoIntegration() {
        const url = this.urlsService.INTEGRATIONS.AVISO_ACTIVATE;
        return this.ajaxService.postJsonDataObserveBody(url, {});
    }
    getAvisoIntegrationStatus() {
        const url = this.urlsService.INTEGRATIONS.AVISO_INTEGRATION_STATUS;
        return this.ajaxService.getDataObserveBody(url);
    }
}
AvisoIntegrationService.ɵfac = function AvisoIntegrationService_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || AvisoIntegrationService)(i0.ɵɵinject(i1.AjaxService), i0.ɵɵinject(i2.UrlsService)); };
AvisoIntegrationService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: AvisoIntegrationService, factory: AvisoIntegrationService.ɵfac, providedIn: 'root' });
